import { MenuCategoryBuilder } from "./menu.category.builder";
import { CategorySchedule } from "./menu.category.schedule.model";
//5 attributes
export class MenuCategory {
  public readonly id: string;
  public readonly name: string;
  public readonly color: string;
  public readonly position: number;
  public readonly image: string;
  public readonly isActive: boolean;
  public readonly schedule: CategorySchedule;

  constructor(builder: MenuCategoryBuilder) {
    this.schedule = builder.schedule;
    this.name = builder.name;
    this.isActive = builder.isActive;
    this.color = builder.color;
    this.position = builder.position;
    this.image = builder.image;
    this.id = builder.id;
  }
}
